import { safeString } from '@utils/stringUtil';
import { CreateDeliveryZonePayload, UpdateDeliveryZonePayload } from '../../models/payload/deliveryZone';
import { ropoloRequest } from '../axios';

const getDeliveryZones = async () => (await ropoloRequest.v1DeliveryZonesList()).data;

const getDeliveryZonesPolygons = async () => (await ropoloRequest.v1PolygonsList()).data;

const createDeliveryZones = async (payload: CreateDeliveryZonePayload) =>
  (
    await ropoloRequest.v1DeliveryZonesUpdate(safeString(payload?.PolygonsId), {
      price: payload.price,
      vendorsProperName: payload?.vendorsProperName,
      enabled: payload?.enabled,
    })
  ).data;

const editDeliveryZone = async (payload: UpdateDeliveryZonePayload) =>
  (await ropoloRequest.identityDeliveryzonesUpdate(payload)).data;

const removeDeliveryZone = async (id: string) => (await ropoloRequest.v1DeliveryZonesDelete(id)).data;

export { getDeliveryZones, createDeliveryZones, editDeliveryZone, removeDeliveryZone, getDeliveryZonesPolygons };
